const interfacePhrases = {
    rate_limited: 'Frecuencia limitada',
    limit_exceeded: 'Límite superado',
    used: 'Uso',
    identifier: 'Identificador',
    verification: 'Verificación',
    messages: 'Mensajes',
    data: 'Datos',
    custom: 'Personalizado',
    management_api: 'API de gestión de {{product}}',
    management_api_role_description: 'Este rol integrado concede acceso a la API de gestión.',
    client_credentials: 'Credenciales del cliente',
    authentication_request: 'Solicitud de autenticación',
    callback: 'Retorno de autenticación',
    help_title: 'Centro de ayuda de iden',
    help_subtitle: 'Ayuda sin salir de tu espacio de trabajo',
    open_help: 'Abrir la página de ayuda completa',
    close_help: 'Cerrar ayuda',
    about: 'Acerca de y código abierto',
    open_navigation: 'Abrir navegación',
    close_navigation: 'Cerrar navegación',
    development_enabled: 'Funciones de desarrollo activadas',
    beta: 'Beta',
    impersonation: 'Suplantación de identidad',
    key: 'Clave',
    value: 'Valor',
    error: 'Error',
    details: 'Detalles técnicos',
    callback_failed: 'No se pudo completar el retorno de inicio de sesión.',
    back_sign_in: 'Volver a iniciar sesión',
    powered_by: 'Desarrollado por',
    avatar: 'Avatar',
    logo: 'Logotipo',
    qr_code: 'Código QR',
    sample_title: '¿Quieres ver un ejemplo?',
    sample_description: 'Explora una aplicación de ejemplo que usa esta guía.',
    sample_action: 'Ver ejemplo',
    further_readings: 'Lecturas adicionales',
    complete_guide: 'Guía completa',
    custom_domains_notice: 'Tras añadir <a>dominios personalizados</a>, puedes usar este punto de conexión: <code>{{endpoint}}</code>.',
    my_project: 'Mi proyecto',
    my_secret: 'Mi secreto',
    my_token: 'Mi token',
    role_example: 'Lector',
    reset_retry: 'Restablecer la configuración y reintentar',
    open_dev_panel: 'Abrir panel de desarrollo',
    close_dev_panel: 'Cerrar panel de desarrollo',
    configuration: 'Configuración',
    app_id: 'Identificador de aplicación',
    extra_parameters: 'Parámetros de inicio de sesión adicionales',
    prompt: 'Solicitud de autenticación',
    scope: 'Ámbito',
    resource: 'Recurso',
    resources_space_delimited: 'Recursos (separados por espacios)',
    sign_out_to_apply: 'Cierra sesión para aplicar los cambios.',
    refresh_token_grant: 'Autorización con token de actualización',
    organization_id: 'Identificador de organización',
    console_result: 'Consulta el resultado en la consola del navegador.',
    request_token: 'Solicitar token',
    user_info: 'Información del usuario',
    get_id_token_claims: 'Obtener declaraciones del token de identidad',
    fetch_user_info: 'Obtener información del usuario',
    device_initializing: 'Inicializando autorización del dispositivo…',
    device_success: 'Has iniciado sesión en la aplicación de demostración.',
    sign_in_information: 'Tu información de inicio de sesión:',
    email: 'Correo electrónico',
    username: 'Nombre de usuario',
    user_id: 'Identificador de usuario',
    sign_out_demo: 'Cerrar sesión de la demostración',
    device_expired: 'Código del dispositivo caducado',
    generic_error: 'Se produjo un error',
    device_expired_description: 'El código del dispositivo ha caducado. Reinténtalo para obtener uno nuevo.',
    sign_in_title: 'Inicia sesión en tu cuenta',
    scan_instruction: 'Escanea el código QR o abre esta dirección en otro dispositivo:',
    one_time_code: 'Introduce el código de un solo uso',
    token_info: 'Información del token',
    get_access_token: 'Obtener token de acceso',
    context_unavailable: 'No se pudo cargar la información de la cuenta.',
    not_initialized: 'La información de la cuenta no está inicializada.',
    not_set: 'Sin definir',
    configured: 'Configurado',
    password: 'Contraseña',
    phone: 'Número de teléfono',
    search_help: 'Buscar ayuda',
    language: 'Idioma',
    menu: 'Menú',
    compatibility_notice: 'Compatibilidad: los nombres heredados de SDK, paquetes, protocolos, componentes y cabeceras de solicitud de Logto no cambian.',
    source: 'Fuente',
    upstream_repository: 'Repositorio original',
    current_fork: 'Repositorio actual',
    license_notice: 'iden se basa en Logto, software de código abierto con licencia Mozilla Public License 2.0.',
    about_description: 'Información del producto y atribución del código abierto.',
    page_not_found: 'Página no encontrada',
    page_not_found_description: 'Esta página no está disponible. Vuelve al centro de ayuda para continuar.',
    introduction: 'Introducción',
    quick_starts: 'Inicio rápido',
    integration: 'Integración',
    end_user_flows: 'Flujos de usuario final',
    authorization: 'Autorización',
    user_management: 'Gestión de usuarios',
    security: 'Seguridad',
    customization: 'Personalización',
    connectors: 'Conectores',
    organizations: 'Organizaciones',
    self_hosting: 'Alojamiento propio',
    continue: 'Continuar',
    loading: 'Cargando…',
    save: 'Guardar',
    saved: 'Guardado',
    try_again: 'Reintentar',
    client_id: 'Identificador del cliente',
    client_secret: 'Secreto del cliente',
    redirect_uri: 'URI de redirección',
    status: 'Estado',
    type: 'Tipo',
    permissions: 'Permisos',
    token_data: 'Datos del token',
    context_data: 'Datos del contexto',
    jwt_extra_claims: 'Declaraciones adicionales del token',
    action_result: 'Resultado de la acción',
    social_account_already_linked: 'Esta cuenta social ya está vinculada.',
};
export default Object.freeze(interfacePhrases);
